module.exports = __webpack_public_path__ + "img/usdt.f07b8f90.svg";